import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';

@Component({
  selector: 'bo-cancel-paid-activity-dialog',
  imports: [TranslateModule, CommonModule, DialogModule, FormsModule],
  templateUrl: './cancel-paid-activity-dialog.component.html',
  styleUrl: './cancel-paid-activity-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CancelPaidActivityDialogComponent {
  @Input() visible = false;
  @Input() closing = false;
  @Input() restoreWithoutTransition = false;
  @Input() confirmed = false;
  @Input() activityName = '';

  @Output() closed = new EventEmitter<void>();
  @Output() hidden = new EventEmitter<void>();
  @Output() confirmedChange = new EventEmitter<boolean>();
  @Output() canceled = new EventEmitter<void>();

  onConfirmedChange(value: boolean) {
    this.confirmedChange.emit(value);
  }

  close() {
    this.closed.emit();
  }

  confirm() {
    this.canceled.emit();
  }

  onHidden() {
    this.hidden.emit();
  }
}
